import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
};

let finalInitialState = JSON.parse(localStorage.getItem('authData')) || initialState;

const authSlice = createSlice({
  name: 'auth',
  initialState : finalInitialState,
  reducers: {
    userlogin: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem('authData', JSON.stringify(state));
    },
    userlogout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
       // Remove state from local storage
       localStorage.removeItem('authData');
    },
  },
});

export const { userlogin, userlogout } = authSlice.actions;
export default authSlice.reducer;

  
